export function gadgets() {
	// noop intentionally blank, all plugins loaded via WRM
}
export function gadgetsWRM() {
	return ['wr!com.atlassian.confluence.plugins.gadgets:macro-browser-for-gadgetsplugin'];
}
